/**
 * Absolute application paths. These serve both as navigation targets
 * (navigate/Link) and as route paths in the router config — react-router v6
 * allows absolute child paths as long as they extend their parent path.
 *
 * Param-carrying URLs are constructed with {@link buildPath}. Route-only
 * patterns (optional params like `:key?`) live in the router config.
 */
const Paths = {
	Root: "/",
	SignInPhone: "/login/phone",
	Email: "/email",
	Reset: "/email/reset",
	Signup: "/signup",
	Phone: "/phone",
	Subscription: "/subscription",
	Setup: "/setup",
	Device: "/setup/device",
	SetupUser: "/setup/user",
	UserInfo: "/setup/user/userinfo",
	EmergencyInfo: "/setup/user/emergency",
	Plans: "/setup/plans",
	Confirmation: "/setup/confirmation",
	DocsRedirect: "/docs-redirect",
	App: "/app",
	Conversations: "/app/conversations",
	ConversationsSettings: "/app/conversations/settings",
	Tracking: "/app/tracking",
	Settings: "/app/settings",
	SettingsType: "/app/settings/:type",
	SettingsStaff: "/app/settings/staff",
	SettingsProfile: "/app/settings/profile",
	SettingsChangelog: "/app/settings/changelog",
	SettingsDownloads: "/app/settings/downloads",
	SettingsEmergency: "/app/settings/emergency",
	SettingsJoinWorkspace: "/app/settings/join-workspace",
	SettingsWorkspace: "/app/settings/workspace",
	SettingsWorkspaces: "/app/settings/workspaces",
	SettingsOrganization: "/app/settings/organization",
	SettingsDevices: "/app/settings/devices",
	SettingsDevicesNewAccount: "/app/settings/devices/newAccount",
	SettingsDevicesSubscriptions: "/app/settings/devices/subscription",
	SettingsDevicesActivate: "/app/settings/devices/activate",
	SettingsDevicesActivateSingle: "/app/settings/devices/activate/single",
	SettingsBilling: "/app/settings/billing",
	ClaimOrganization: "/app/claim-organization",
	PublicTrackingMatch: "/public/tracking/:uuid",
} as const;

export type Path = (typeof Paths)[keyof typeof Paths];

/**
 * The `:key` route param value that renders conversation settings rather than a
 * conversation. Matches the trailing segment of {@link Paths.ConversationsSettings}.
 */
export const CONVERSATION_SETTINGS_KEY = "settings";

/** Typed builders for param-carrying navigation targets. */
export const buildPath = {
	conversation: (key: string) => `${Paths.Conversations}/${key}`,
	subscriptionDetail: (subscriptionCode: string) =>
		`${Paths.SettingsDevicesSubscriptions}/${subscriptionCode}`,
} as const;

export default Paths;
